/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_New_TitleInputs */

const vi_cdo_new_title = /** @type {(inputs: Cdo_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo đơn giao hợp đồng`)
};

/**

* @param {Cdo_New_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_new_title = /** @type {((inputs?: Cdo_New_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_New_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_new_title(inputs)
});